import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class AviaExtension extends AbstractTagClass {
    package;
    #loaded;
    get namespaceBase() {
        return this?.tag?.model?.config?.tag?.Imports?.params?.avia;
    }
    get extensionConfig() {
        return this?.namespaceBase?.[this.namespaceKey];
    }
    get namespaceComplete() {
        return this?.extensionConfig?.namespace;
    }
    get enabled() {
        return this?.extensionConfig?.enabled;
    }
    get preloadedExtension() {
        if (this.utils.Type.isEmpty(this.namespaceComplete) || !this.utils.Type.isString(this.namespaceComplete)) {
            return undefined;
        }
        const preloadedPackage = this.utils.DOM.getDeepVal(window, this.namespaceComplete);
        if (!this.utils.Type.isNullOrUndefined(preloadedPackage)) {
            return preloadedPackage?.extension;
        }
        return undefined;
    }
    get builder() {
        this?.logger?.log('getExtensionBuilder', this);
        let builderFunction = undefined;
        const preloadedExtension = this.preloadedExtension;
        this?.logger?.log('preloadedExtension', preloadedExtension);
        if (!this.utils.Type.isNullOrUndefined(preloadedExtension)) {
            this?.logger?.log('Extension was preloaded: ', 'preloadedExtension =', preloadedExtension);
            builderFunction = preloadedExtension;
        }
        else if (!this.utils.Type.isNullOrUndefined(this.package)) {
            this?.logger?.log('Extension package was used: ', 'this.package =', this.package);
            builderFunction = this.package;
        }
        if (this.utils.Type.isNullOrUndefined(builderFunction)) {
            this?.logger?.warn('Extension was neither imported nor loaded', this.namespaceComplete, this.package);
        }
        return builderFunction;
    }
    constructor(argument) {
        super(argument);
    }
    shouldBeUsed() {
        if (this.#loaded) {
            this?.logger?.log('Extension already loaded');
        }
        if (this?.enabled !== true) {
            this?.logger?.log('Extension is not enabled');
        }
        return this?.enabled === true && !this.#loaded;
    }
    register() {
        this?.logger?.log('register', 'this', this, 'Extension package: ', 'this.package =', this.package);
        if (!this.package) {
            return Promise.resolve();
        }
        if (!window.avia?.use) {
            this?.logger?.warn('window.avia.use is unavailable');
            return Promise.reject('window.avia.use is unavailable');
        }
        return window.avia?.use?.(this.builder(this.getExtensionParams()))?.then(() => {
            this.#loaded = true;
        });
    }
    getExtensionParams() {
        return {
            debug: this.runtimeVO?.debug?.player
        };
    }
}
